import { Component, HostListener, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DataService } from '../../core/services/data.service';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class NavComponent implements OnInit {
  constructor(private _DataService: DataService) {}
  isSidebarOpen = false;
  allDestinations: any[] = [];
  allCategories: any[] = [];
  isHovered = false;

  logo: any;
  phoneNunmber: any;

  // nav scroll code

  compactHeader = false;
  private readonly SHOW_THRESHOLD = 0;

  @HostListener('window:scroll', [])
  onScroll() {
    const rawY = window.scrollY ?? document.documentElement.scrollTop ?? 0;
    const y = Math.max(0, rawY);

    this.compactHeader = y > this.SHOW_THRESHOLD;
  }

  // -------- end scroll code

  ngOnInit(): void {
    this.getDestination();
    this.getSettings();
    this.getCategories();
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    if (this.isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeSidebar() {
    this.isSidebarOpen = false;
    document.body.style.overflow = '';
  }

  navigationLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/blog', label: 'Blogs' },
    { path: '/contact', label: 'Contact' },
  ];

  getDestination() {
    this._DataService.getDestination().subscribe({
      next: (res) => {
        // console.log(res.data.data);
        this.allDestinations = res.data.data;
      },
      error: (err) => {
        // console.log(err);
      },
    });
  }

  getCategories() {
    this._DataService.getCategories().subscribe({
      next: (res) => {
        console.log(res.data.data);
        this.allCategories = res.data.data;
      },
      error: (err) => {
        // console.log(err);
      },
    });
  }

  getSettings(): void {
    this._DataService.getSetting().subscribe({
      next: (res) => {
        console.log(res.data);

        const contactLogo = res.data.find(
          (item: any) => item.option_key === 'logo'
        );
        this.logo = contactLogo?.option_value[0];

        const contactPhone = res.data.find(
          (item: any) => item.option_key === 'CONTACT_PHONE_NUMBER'
        );
        this.phoneNunmber = contactPhone?.option_value[0];

        // console.log(this.logo);
      },
      error: (err) => {
        // console.log(err);
      },
    });
  }
}
